import { createContext } from "react";

export const ChatContext = createContext<any | undefined>({});
